import { Helmet } from 'react-helmet-async';

// Reusable schema.org JSON-LD injector — same component as akkubolt's
// src/components/JsonLd/JsonLd.tsx. Renders one <script type="application/ld+json">
// inside Helmet, which react-helmet-async hoists into <head>. Google JS-renders
// this on the CSR shell today; the build-time prerender (scripts/prerender.mjs)
// also bakes it into the static snapshots non-JS AI crawlers read.
export default function JsonLd({ data }: { data: Record<string, unknown> | Record<string, unknown>[] }) {
	// Escape any literal </script> so an article title/slug can never break out of the tag.
	const json = JSON.stringify(data).replace(/<\/(script)/gi, '<\\/$1');
	return (
		<Helmet>
			<script type="application/ld+json">{json}</script>
		</Helmet>
	);
}
